import { apiSlice } from 'state/slices/apiSlice';

const DESIGNATIONS_URL = '/designations';

export const designationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createDesignation: builder.mutation({
      query: (designationData) => ({
        url: `${DESIGNATIONS_URL}/create`,
        method: 'POST',
        body: designationData,
        transformResponse: (response) => response.json(),
      }),
    }),
    getDesignations: builder.query({
      query: () => `${DESIGNATIONS_URL}/list`,
    }),
    updateDesignation: builder.mutation({
      query: ({ id, data }) => {
        return {
          url: `${DESIGNATIONS_URL}/update`,
          method: 'PUT',
          body: { id, ...data },
        };
      },
    }),
    deleteDesignation: builder.mutation({
      query: (id) => ({
        url: `${DESIGNATIONS_URL}/delete`,
        method: 'DELETE',
        body: { id },
      }),
    }),
  }),
});

export const {
  useCreateDesignationMutation,
  useGetDesignationsQuery,
  useUpdateDesignationMutation,
  useDeleteDesignationMutation,
} = designationApiSlice;
